import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { BehaviorSubject, first, Observable, Subject, takeUntil } from 'rxjs';
import { LgvClientService, NotificationService } from '../../core/core.module';
// import { BehaviorSubject } from 'rxjs';
import { LgvPublicRecordModel } from '../../data-models/lgv-publicRecord.model';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
// import { environment as env } from '../../../environments/environment';
// import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'lus-public-record-result',
    templateUrl: './public-record-result.component.html',
    styleUrls: ['./public-record-result.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicRecordResultComponent implements OnInit, OnDestroy {
    @Input() PublicRecord$: Observable<LgvPublicRecordModel.PublicRecord>;
    @Input() Status$: Observable<any[]>;
    @Input() ShowMakeCurrentButton: boolean;

    ConfirmationHTML: SafeHtml;
    IsLoading: boolean = false;
    IsLoading$ = new BehaviorSubject(this.IsLoading);
    onDestroy$ = new Subject();
    isOwnedProperty: boolean;
    // _IsLoading: boolean = false;
    // IsLoading$ = new BehaviorSubject(this._IsLoading);
    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        public LgvClientSvc: LgvClientService,
        private notificationsService: NotificationService,
        public MatDialog: MatDialog
    ) { }

    ngOnInit() {
        this.isOwnedProperty = this.LgvClientSvc.SelectedProperty$.value?.associationType === 'Owned';
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    makeAsCurrentLoan(prlr: LgvPublicRecordModel.PublicRecordLienResult, pr: LgvPublicRecordModel.PublicRecord) {
        const confDialogRef = this.MatDialog.open(ConfirmationDialogComponent, {
            width: '250px',
            data: { Confirmation: `Are you sure you want to make this as current loan?` }
        });

        confDialogRef.afterClosed().pipe(takeUntil(this.onDestroy$)).subscribe(x => {
            if (x.action == true) {
                this.IsLoading$.next(true);

                console.log('PR:');
                console.log(pr);

                const propertyId = this.LgvClientSvc.SelectedProperty$?.value?.propertyInfo?.id;
                if (!(!!propertyId)) {
                    console.log('Unable to obtain property ID');
                    this.notificationsService.error('Error trying to retrieve the ID for this property');
                    return;
                }

                this.LgvClientSvc.MakeDTResultTheActiveLoan(pr.request.id, pr.result.id).pipe(takeUntil(this.onDestroy$)).subscribe(res => {
                    this.LgvClientSvc.LoadSnapshotForNonClient(this.LgvClientSvc.SavedImpersonatedClientID, true);
                    this.LgvClientSvc.HaveIncompleteLoanInformation$.next(true);
                    this.notificationsService.success("Loan Creation Success!");
                    this.IsLoading$.next(false);
                    this.dialogRef.close({ action: true });

                }, (err) => {
                    this.notificationsService.error("Loan Creation Error");
                    console.log(err);
                });

            }
        })
    }

}
